import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import UnoM from './MarketingPages/UnoM';
import DosM from './MarketingPages/DosM';
import TresM from './MarketingPages/TresM';
import CuatroM from './MarketingPages/CuatroM';
import CincoM from './MarketingPages/CincoM';
import ReferenceM from './MarketingPages/ReferenceM';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const EntrepreneurshipCS = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const [backV, setBackV] = useState('transparent');
  const [backVI, setBackVI] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#PDE') {
      setBackI(appColors['ColorE']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
    } else if (key === '#CNE') {
      setBackI('transparent');
      setBackII(appColors['ColorE']);
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
    } else if (key === '#SHE') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorE']);
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
    } else if (key === '#VE') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorE']);
      setBackV('transparent');
      setBackVI('transparent');
    } else if (key === '#RE') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV(appColors['ColorE']);
      setBackVI('transparent');
    } else if (key === '#RE2') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI(appColors['ColorE']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#PDE' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorE'], fontSize: '2.4vh'}}>Market Size</Text></Content>}/>
          <Link href='#CNE' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorE'], fontSize: '2.4vh'}}>Market Target</Text></Content>}/>
          <Link href='#SHE' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorE'], fontSize: '2vh'}}>Competitor Analysis</Text></Content>}/>
          <Link href='#VE' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorE'], fontSize: '2vh'}}>Marketing Strategy</Text></Content>}/>
          <Link href='#RE' title={<Content className='ContentAnchor' style={{borderColor: backV}}><Text style={{color: appColors['ColorE'], fontSize: '3vh'}}>Validation</Text></Content>}/>
          <Link href='#RE2' title={<Content className='ContentAnchor' style={{borderColor: backVI}}><Text style={{color: appColors['ColorE'], fontSize: '3vh'}}>References</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorE'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> M&nbsp;<br/> A&nbsp;<br/> R&nbsp;<br/> K&nbsp;<br/> E&nbsp;<br/> T&nbsp;<br/> I&nbsp;<br/> N&nbsp;<br/> G&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['Colorx'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='PDE'>
              <UnoM/>
            </div>
            <div id='CNE'>
              <DosM/>
            </div>
            <div id='SHE'>
              <TresM/>
            </div>
            <div id='VE'>
              <CuatroM/>
            </div>
            <div id='RE'>
              <CincoM/>
            </div>
            <div id='RE2'>
              <ReferenceM/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default EntrepreneurshipCS;
